"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthSocial = exports.HandleType = exports.AssetNameLabel = exports.Rarity = void 0;
var Rarity;
(function (Rarity) {
    Rarity["basic"] = "basic";
    Rarity["common"] = "common";
    Rarity["rare"] = "rare";
    Rarity["ultra_rare"] = "ultra_rare";
    Rarity["legendary"] = "legendary"; // - 1 character
})(Rarity = exports.Rarity || (exports.Rarity = {}));
/**
 * The asset label is a string that is used to identify the asset type.
 * First, remove the first and last 0.
 * Next, use the first 4 characters as the hex and convert to decimal. https://www.rapidtables.com/convert/number/hex-to-decimal.html
 * Finally, use the decimal number and convert to CRC8. It should match the last 2 characters. https://crccalc.com/
 */
var AssetNameLabel;
(function (AssetNameLabel) {
    AssetNameLabel["LABEL_000"] = "00000000";
    AssetNameLabel["LABEL_100"] = "000643b0";
    AssetNameLabel["LABEL_222"] = "000de140";
    AssetNameLabel["LABEL_333"] = "0014df10";
    AssetNameLabel["LABEL_444"] = "001bc280"; // 444
})(AssetNameLabel = exports.AssetNameLabel || (exports.AssetNameLabel = {}));
var HandleType;
(function (HandleType) {
    HandleType["VIRTUAL_SUBHANDLE"] = "virtual_subhandle";
    HandleType["NFT_SUBHANDLE"] = "nft_subhandle";
    HandleType["HANDLE"] = "handle";
})(HandleType = exports.HandleType || (exports.HandleType = {}));
var OAuthSocial;
(function (OAuthSocial) {
    OAuthSocial[OAuthSocial["twitter"] = 0] = "twitter";
    OAuthSocial[OAuthSocial["facebook"] = 1] = "facebook";
    OAuthSocial[OAuthSocial["discord"] = 2] = "discord";
    OAuthSocial[OAuthSocial["instagram"] = 3] = "instagram";
    OAuthSocial[OAuthSocial["tiktok"] = 4] = "tiktok";
    OAuthSocial[OAuthSocial["youtube"] = 5] = "youtube";
    OAuthSocial[OAuthSocial["twitch"] = 6] = "twitch";
    OAuthSocial[OAuthSocial["linkedin"] = 7] = "linkedin";
    OAuthSocial[OAuthSocial["snapchat"] = 8] = "snapchat";
    OAuthSocial[OAuthSocial["telegram"] = 9] = "telegram";
    OAuthSocial[OAuthSocial["whatsapp"] = 10] = "whatsapp";
    OAuthSocial[OAuthSocial["medium"] = 11] = "medium";
    OAuthSocial[OAuthSocial["github"] = 12] = "github";
    OAuthSocial[OAuthSocial["reddit"] = 13] = "reddit";
    OAuthSocial[OAuthSocial["pinterest"] = 14] = "pinterest";
    OAuthSocial[OAuthSocial["pin"] = 15] = "pin";
    OAuthSocial[OAuthSocial["spotify"] = 16] = "spotify";
    OAuthSocial[OAuthSocial["soundcloud"] = 17] = "soundcloud";
    OAuthSocial[OAuthSocial["paypal"] = 18] = "paypal";
})(OAuthSocial = exports.OAuthSocial || (exports.OAuthSocial = {}));
